// Pesan aman hasil "Tes Koneksi" Jubelio — kode kategori dari backend, tanpa token/secret/payload upstream.
export const TEST_CONNECTION_COPY = {
  CONNECTED: {
    title: "Koneksi Jubelio berhasil.",
    body: "Client ID dan Client Secret berhasil diverifikasi.",
  },
  NOT_CONFIGURED: {
    title: "Pengaturan belum siap.",
    body: "Simpan Client ID dan Client Secret lalu aktifkan Jubelio terlebih dahulu, kemudian klik Tes Koneksi.",
  },
  AUTH_FAILED: {
    title: "Autentikasi Jubelio gagal.",
    body: "Periksa kembali Client ID dan Client Secret.",
  },
  FORBIDDEN: {
    title: "Akses ditolak oleh Jubelio.",
    body: "Periksa hak akses API key pada akun Jubelio Anda.",
  },
  RATE_LIMITED: {
    title: "Permintaan ke Jubelio terlalu banyak.",
    body: "Coba lagi beberapa saat.",
  },
  NETWORK_ERROR: {
    title: "Tidak dapat terhubung ke server Jubelio.",
    body: "Coba lagi.",
  },
  JUBELIO_UNAVAILABLE: {
    title: "Server Jubelio sedang bermasalah.",
    body: "Coba lagi nanti.",
  },
  CONNECTION_FAILED: {
    title: "Koneksi ke Jubelio gagal.",
    body: "Coba lagi atau hubungi dukungan Dynicty.",
  },
};

const KNOWN = new Set(Object.keys(TEST_CONNECTION_COPY));

// Response 200 dari backend → {ok, code, title, body}
export function describeTestConnection(data) {
  const ok = !!data?.ok;
  let code = KNOWN.has(data?.code) ? data.code : ok ? "CONNECTED" : "CONNECTION_FAILED";
  if (ok && code !== "CONNECTED") code = "CONNECTED";
  if (!ok && code === "CONNECTED") code = "CONNECTION_FAILED";
  const copy = TEST_CONNECTION_COPY[code];
  // Pesan backend spesifik (mis. Base URL tidak valid) hanya dipakai bila bukan kategori standar berpesan tetap.
  const body = code === "CONNECTION_FAILED" && typeof data?.message === "string" && data.message ? data.message : copy.body;
  return { ok, code, title: copy.title, body };
}

// Error HTTP/axios (403 feature gate, 429 proxy, 5xx, network) → kategori aman.
export function describeTestConnectionError(err) {
  const status = err?.response?.status;
  let code = "CONNECTION_FAILED";
  if (status === 429) code = "RATE_LIMITED";
  else if (!status) code = "NETWORK_ERROR";
  const copy = TEST_CONNECTION_COPY[code];
  return { ok: false, code, title: copy.title, body: copy.body };
}
